var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromotionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#123766"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16.0039C9.5 15.5392 9.5 15.3069 9.53843 15.1137C9.69624 14.3203 10.3164 13.7001 11.1098 13.5423C11.303 13.5039 11.5353 13.5039 12 13.5039H18.5H25C25.4647 13.5039 25.697 13.5039 25.8902 13.5423C26.6836 13.7001 27.3038 14.3203 27.4616 15.1137C27.5 15.3069 27.5 15.5392 27.5 16.0039C27.5 16.4686 27.5 16.7009 27.4616 16.8941C27.3038 17.6875 26.6836 18.3077 25.8902 18.4655C25.697 18.5039 25.4647 18.5039 25 18.5039H18.5H12C11.5353 18.5039 11.303 18.5039 11.1098 18.4655C10.3164 18.3077 9.69624 17.6875 9.53843 16.8941C9.5 16.7009 9.5 16.4686 9.5 16.0039Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18.5039V22.5039C10.5 24.3895 10.5 25.3323 11.0858 25.9181C11.6716 26.5039 12.6144 26.5039 14.5 26.5039H15.5H21.5H22.5C24.3856 26.5039 25.3284 26.5039 25.9142 25.9181C26.5 25.3323 26.5 24.3895 26.5 22.5039V18.5039",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 13.5039V26.5039",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8753 12.7239L15.8959 10.2496C15.1513 9.31882 13.761 9.24374 12.9182 10.0866C11.6582 11.3466 12.5466 13.5048 14.3285 13.5048H17.5C17.903 13.5048 18.1271 13.0386 17.8753 12.7239Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1247 12.7239L21.1041 10.2496C21.8488 9.31882 23.239 9.24374 24.0819 10.0866C25.3418 11.3466 24.4534 13.5048 22.6716 13.5048H19.5C19.097 13.5048 18.8729 13.0386 19.1247 12.7239Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionIcon);
export default __webpack_public_path__ + "static/media/promotionIcon.3160870a961474977cd41031f57bf9e6.svg";
export { ForwardRef as ReactComponent };